import React from "react";
import "./Liputan.css";

const Liputan = () => {
  return (
    <React.Fragment>
      <div className="container-liputan">
        <h1 className="title-liputan">Telah Diliput Oleh Media</h1>
        <div className="box-liputan">
          <img
            src="https://app.edumatrix-indonesia.com/static/media/tribun_jogja.b2c4023c19bace5ae4e9.jpg"
            alt="Bimbel Polri Terbaik"
            className="img-liputan"
          />
          <img
            src="https://app.edumatrix-indonesia.com/static/media/jogja_aja.56882856bfba48bb20dd.jpg"
            alt="Bimbel Polri Terbaik"
            className="img-liputan"
          />
          <img
            src="https://app.edumatrix-indonesia.com/static/media/liputan_6.c6f1e943acbdeb908562.jpg"
            alt="Bimbel Polri Terbaik"
            className="img-liputan"
          />
          <img
            src="https://app.edumatrix-indonesia.com/static/media/krjogja.66db22bae63bc5ffca6b.jpg"
            alt="Bimbel Polri Terbaik"
            className="img-liputan"
          />
          <img
            src="https://tarunapersada.com/storage/images/media-massa/kumparan.webp"
            alt="Bimbel Polri Terbaik"
            className="img-liputan"
          />
          <img
            src="https://app.edumatrix-indonesia.com/static/media/idn_times.0de5d1b523289ed95f3b.jpg"
            alt="Bimbel Polri Terbaik"
            className="img-liputan"
          />
          <img
            src="https://app.edumatrix-indonesia.com/static/media/jawa_post.c135d20bb5fa7d62686e.png"
            alt="Bimbel Polri Terbaik"
            className="img-liputan"
          />
          <img
            src="https://app.edumatrix-indonesia.com/static/media/kompas.73bc617ec6cbd13debb1.jpg"
            alt="Bimbel Polri Terbaik"
            className="img-liputan"
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default Liputan;
